<template>
    <div>
    </div>
</template>

<script>
export default {
    name:'DoveMedRecommendedPage',
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/home/DoveMedRecommendedPage.vue